import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { currencyBRL } from "../../util/DoubleUtil";
import { dateTimeFormat } from "../../util/DateUtil";

export const InfoItem = ({ label, value, wide }) => (
  <Grid size={{ xs: 12, sm: wide ? 12 : 6, md: wide ? 12 : 4 }}>
    <Typography variant="caption" color="text.secondary" component="div">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>
      {value === null || value === undefined || value === "" ? "--" : value}
    </Typography>
  </Grid>
);

/** Detalhes completos de uma transação Pix. */
const PixTransacaoView = ({ pixTransacao }) => (
  <Stack direction={{ xs: "column", md: "row" }} spacing={2.5}>
    {pixTransacao?.qrCodeImagem && (
      <Box
        component="img"
        src={pixTransacao.qrCodeImagem}
        alt="QR Code Pix"
        sx={{ width: 140, height: 140, borderRadius: 1, border: 1, borderColor: "divider", flexShrink: 0 }}
      />
    )}
    <Grid container spacing={2} flexGrow={1}>
      <InfoItem label="Código" value={pixTransacao?.codigo} />
      <InfoItem label="Identificador" value={pixTransacao?.identificador} />
      <InfoItem label="Tipo" value={pixTransacao?.tipo} />
      <InfoItem label="Valor" value={currencyBRL(pixTransacao?.valor)} />
      <InfoItem label="Valor pago" value={pixTransacao?.valorPago ? currencyBRL(pixTransacao.valorPago) : null} />
      <InfoItem label="Data do pagamento" value={dateTimeFormat(pixTransacao?.dataPagamento)} />
      <InfoItem label="Quitado" value={pixTransacao?.quitado ? "Sim" : "Não"} />
      <InfoItem label="Cliente" value={pixTransacao?.clienteNome} />
      <InfoItem label="CPF/CNPJ" value={pixTransacao?.clienteCPFCNPJ} />
      <InfoItem label="Expiração (segundos)" value={pixTransacao?.segundosExpiracao} />
      <InfoItem label="Descrição" value={pixTransacao?.clienteDescricao} wide />
      <InfoItem label="Retorno" value={pixTransacao?.retorno} wide />
      {pixTransacao?.detalhesErro && <InfoItem label="Detalhes do erro" value={pixTransacao.detalhesErro} wide />}
      <InfoItem label="Pix copia e cola" value={pixTransacao?.qrCodeTexto} wide />
    </Grid>
  </Stack>
);

export default PixTransacaoView;
